import {
  type CreateMcpTokenBody,
  type CreatedMcpToken,
  type McpToken,
  type McpTokenList,
  createdMcpTokenSchema,
  mcpTokenListSchema,
  mcpTokenSchema,
} from '@mss_creator/shared';
import { request } from './api';

/**
 * Personal MCP tokens of the signed-in `pms_admin` (issue #31, spec D3, D4,
 * D21). Every route is scoped to `/me`: no user id ever travels from here, and
 * the plaintext value only comes back once, from the creation.
 */
export const mcpTokensApi = {
  /** The caller's tokens on this environment, active ones first, with the environment and the ceiling. */
  list: (): Promise<McpTokenList> => request('/me/mcp-tokens', mcpTokenListSchema),
  /** 201 with the plaintext `value`; 409 `MCP_TOKEN_LIMIT_REACHED` when the ceiling is reached. */
  create: (input: CreateMcpTokenBody): Promise<CreatedMcpToken> =>
    request('/me/mcp-tokens', createdMcpTokenSchema, {
      method: 'POST',
      body: JSON.stringify(input),
    }),
  /** Revocation is final; the token stays in the list as « Révoqué ». */
  revoke: (id: string): Promise<McpToken> =>
    request(`/me/mcp-tokens/${id}/revoke`, mcpTokenSchema, { method: 'POST' }),
};
